// src/screens/Calendar/SevenDayView.js
export const SevenDayView = {
  // Use built-in week view logic and override range/title
  range: (date, { localizer }) => {
    const start = localizer.startOf(date, "week"); // Sunday
    const days = [];

    for (let i = 0; i < 7; i++) {
      days.push(localizer.add(start, i, "day"));
    }

    return days;
  },
  title: (date, { localizer }) => {
    const start = localizer.startOf(date, "week");
    const end = localizer.endOf(date, "week");
    return `${localizer.format(start, "MMM D")} – ${localizer.format(
      end,
      "MMM D"
    )}`;
  },
};
